import firebase from '../../firebase';

export default async function updateRide(params) {
    return firebase.functions().httpsCallable('rides-update')(params);
}
